/**
 * Vendor
 */
import { Fragment } from "react";
import LazyLoad from "react-lazyload";

import { AutoConvertPriceWithUnit } from "common/priceConvert";

/** ========== */
/* Components
 */
import ButtonNew from "components/atoms/ButtonNew/index";
import CheckContent from "components/atoms/CheckContent";
import Img from "components/atoms/Img";
import TawkToButton from "components/atoms/TawkToButton/index";
import Title from "components/atoms/Title";
import FormCountries from "components/molecules/FormCountries";
import FormNewsLetter from "components/molecules/FormNewsletter";
import RefundGuarantee from "components/molecules/RefundGuarantee";
import Banner from "components/organisms/Banner";
import EbookDownload from "components/organisms/EbookDownload/index";
import Faqs from "components/organisms/Faqs";
import HowItWorks from "components/organisms/HowItWorks";
import NewsSlider from "components/organisms/NewsSlider";
import OffshoreCompanyRegistration from "components/organisms/OffshoreCompanyRegistration";
import RequiredDocument from "components/organisms/RequiredDocument";
import StepSlider from "components/organisms/StepSlider";
import WhatMakeUsDifferent from "components/organisms/WhatMakeUsDifferent";
import WhyChooseUs from "components/organisms/WhyChooseUs/index";

import SGPackage from "./SGPackage/index";

import styles from "./Index.module.scss";

const SGForeigner = ({ data, dataJson }) => {
  return (
    <>
      <Banner
        minHeightBanner="banner-min-h-635"
        breadcrumbs={dataJson.breadcrumbs}
        title={"Singapore Company<br/> Incorporation For<br/> Foreigners"}
        titleProps={{
          className: "banner-default-title mb-6 lg:mb-10 capitalize",
          textColor: "banner-title-default-color",
        }}
        leftClassName="lg:col-7"
        rightClassName="lg:col-5"
        rightContent={
          <Img
            src={
              "/assets/images/sg/company-incorporation-foreigners/banner-company-incorporation-foreigners.png"
            }
            wrapper={{
              className: "bbc-banner-image-country pb-10 lg:pb-0 ",
            }}
            className="w-full"
            width={560}
            height={456}
            priority={true}
            alt="Singapore company incorporation service"
          />
        }
        bgColor={"bg-bbc-country"}
        dataTrustpilot={{
          className: "mb-4 lg:mb-6",
          dataStatic: dataJson.dataTrustpilot,
          dataDefault: data.dataTrustpilot,
        }}
        leftContent={
          <div className="mx-auto mb-6 flex w-fit flex-col items-center lg:mb-12 lg:w-full lg:flex-row lg:pb-1.5 ">
            <TawkToButton othersClass="lg:mr-6 mb-3 lg:mb-0 w-fit lg:whitespace-nowrap border border-bbc-brand-500 capitalize">
              Talk to our expert
            </TawkToButton>
            <ButtonNew
              variant={"outline"}
              useRouter
              as="a"
              href="/contact-us"
              othersClass={"w-full text-center lg:w-fit capitalize"}
            >
              Contact us
            </ButtonNew>
          </div>
        }
      />

      <section className="mt-10 lg:mb-0 lg:mt-20 ">
        <OffshoreCompanyRegistration data={dataJson.dataRegistration} />
      </section>
      <Img
        src="/assets/images/wave/opposition-wave.png"
        width={1920}
        height={86}
        className="hidden w-full lg:block"
        wrapper={{ className: "w-full" }}
        alt="Wave opposition"
      />
      <div className="lg:bg-bbc-brand-100">
        <div className="container ">
          <div className="pt-0 lg:pt-20"></div>
          <SGPackage data={data} {...dataJson.dataPackage} />
          <RefundGuarantee className="mb-10 pt-10 lg:mb-20" />
        </div>
        <section className="container">
          <div className=" text-center">
            <Title
              text={"Additional services"}
              className={"bbc-title mb-4 text-center lg:mb-2"}
            />
            <p>* Extra courier fees apply </p>
          </div>
          <div className="mx-auto mt-6 grid gap-6 lg:mt-10 lg:w-4/5 lg:grid-cols-2 lg:gap-10">
            {dataJson.dataAdditionalServices.map((item, index) => (
              <div
                key={index}
                className={
                  " shadow-bbc  justify-between rounded-3xl bg-white py-8 text-center lg:py-11"
                }
              >
                <p
                  className={
                    " border-b px-4 pb-10 text-2xl font-semibold leading-9  text-bbc-brand-700  lg:px-8 lg:pb-8"
                  }
                >
                  {item.service}
                </p>
                <p className={`${styles.fee} pt-10 lg:pt-8`}>
                  {AutoConvertPriceWithUnit(item.fee, item.unit || 1)}
                </p>
              </div>
            ))}
          </div>
        </section>
        <WhyChooseUs
          title={dataJson?.dataWhyChooseUs?.title}
          note={dataJson?.dataWhyChooseUs?.note}
          sectionClassName="bg-bbc-gradient-3 py-10 lg:py-20"
          data={dataJson?.dataWhyChooseUs?.listIcons}
        >
          <div className="mt-10  text-center ">
            <ButtonNew
              variant={"outline"}
              btnDisplay="inline-block"
              btnColor="bg-transparent hover:bg-white"
              btnBorder="border-2 border-white "
              btnTextColor={"text-white hover:text-bbc-brand-500"}
              btnTextWeight="font-500"
              othersClass="mx-autocapitalize"
              as="a"
              href="/sg/accounting-and-auditing"
            >
              Explore our services
            </ButtonNew>
          </div>
        </WhyChooseUs>

        <section>
          {dataJson.dataOpenBankAccount &&
            typeof dataJson.dataOpenBankAccount === "object" &&
            Object.keys(dataJson.dataOpenBankAccount).length > 0 && (
              <StepSlider
                data={dataJson.dataOpenBankAccount}
                className="pt-0 lg:pt-0"
                title={dataJson.dataOpenBankAccount.title}
                imgAlt={dataJson.dataOpenBankAccount.alt}
              />
            )}
        </section>
        <section>
          <RequiredDocument
            title="What documents to prepare?"
            data={dataJson.dataRequiredDocument}
            sectionClassName="py-10 lg:py-20"
            backgroundImage="/assets/images/common/required-documents.png"
          />
        </section>
        <section>
          <div className="container">
            <EbookDownload
              title={dataJson.dataEbookDownload.title}
              imgSrc={dataJson.dataEbookDownload.imgSrc}
              imgLeftSrc={dataJson.dataEbookDownload.imgLeftSrc}
              triggerName={dataJson.dataEbookDownload.triggerName}
              apiLink={dataJson.dataEbookDownload.apiLink}
              contactFromId={dataJson.dataEbookDownload.contactFromId}
              hash={dataJson.dataEbookDownload.hash}
              dataForm={dataJson.dataEbookDownload.dataForm}
              wrapper={{ className: "mb-10 lg:mb-20" }}
              alt={dataJson.dataEbookDownload.alt}
            >
              <p className="mb-6">
                Chart out a clear roadmap towards company formation with our
                Singapore Incorporation checklist. Start your journey with the
                following insights on
              </p>
              <ul>
                {[
                  "Company pre-incorporation requirements",
                  "Compact guideline of application procedures",
                  "Checklist of business licenses",
                  "Post-incorporation and annual compliance keynotes",
                ].map((item, index) => (
                  <li key={index} className="mb-2 last:mb-0">
                    <CheckContent data={item} />
                  </li>
                ))}
              </ul>
            </EbookDownload>
          </div>
        </section>
        <section className="container">
          <div className=" mx-auto lg:w-3/5 ">
            <Title
              text={"Singapore Employment Pass"}
              className={"bbc-title mb-4 text-center lg:mb-6"}
            />
            <p className="mb-6 lg:mb-11 lg:text-center">
              We help foreign professionals, managers, and executives get an
              Employment Pass to work and live in Singapore, quickly and
              effortlessly
            </p>
          </div>

          <div className="row ">
            <div className="flex flex-col justify-end lg:col-6 ">
              <Title
                as="h3"
                text={"Eligibility criteria"}
                className={
                  "bbc-title mb-4 block text-center  text-lg leading-9 text-bbc-brand-700 lg:mb-6 lg:text-2xl"
                }
              />

              <div className="mb-1 grid-cols-2 grid-rows-2 gap-x-8 gap-y-6 lg:mb-0 lg:grid">
                {[
                  {
                    title: "Fixed monthly<br class='hidden lg:block'/> salary ",
                    icon: "doc-dollar.svg",
                  },
                  {
                    title: "Educational qualifications",
                    icon: "qualification.svg",
                  },
                  {
                    title: "A job offer in Singapore",
                    icon: "human-on-hand.svg",
                  },
                  {
                    title: "Relevant skills and background",
                    icon: "think-setting.svg",
                  },
                ].map((item, index) => {
                  return (
                    <Fragment key={index}>
                      <div className="hidden flex-col items-center justify-center rounded-lg lg:flex lg:bg-white lg:p-6 lg:shadow-[0px_12px_32px_rgba(181,181,181,0.2)]">
                        <Img
                          src={`/assets/icons/${item.icon}`}
                          wrapper={{ className: "mb-2 block" }}
                        />
                        <div
                          className="text-center text-lg font-medium leading-bbc-26 text-bbc-brand-700"
                          dangerouslySetInnerHTML={{ __html: item.title }}
                        />
                      </div>
                      <div className=" mb-2 block lg:hidden">
                        <CheckContent key={index} data={item.title} />
                      </div>
                    </Fragment>
                  );
                })}
              </div>
            </div>
            <div className="lg:col-6">
              <Img
                src="/assets/images/sg/company-incorporation-foreigners/singapore-employment-pass.png"
                className="h-auto w-full"
                wrapper={{ className: "block" }}
                width={621}
                height={496}
              />
            </div>
            <div className="mt-4 text-center capitalize lg:col-6 lg:mt-10">
              {/* <ButtonNew as="a" href="/sg/accounting-and-auditing">
                Get your EP now
              </ButtonNew> */}
              <TawkToButton>Get your EP now</TawkToButton>
            </div>
          </div>
        </section>
        <section>
          <HowItWorks
            title="How we register your company"
            subTitle="in 4 easy steps"
            data={dataJson.dataHowItWorks}
          />
        </section>
        <section className="container">
          <div className="row mb-10 items-center lg:mb-20">
            <div className="justify-self-start lg:col-6">
              <div className="h-full">
                <Title
                  text="Bring Your Next<br/> Business Venture Online"
                  className="bbc-title mb-6 text-center text-bbc-30px text-bbc-brand-800 lg:mb-0 lg:text-left lg:text-bbc-40px"
                />
              </div>
            </div>
            <div className="lg:col-6">
              <div className="h-full">
                <LazyLoad>
                  <iframe
                    src="https://www.youtube.com/embed/8RkJwKEXKPU?start=2"
                    width="540"
                    height="303"
                    frameBorder="0"
                    title="Bring your next business venture online"
                    allow="accelerometer; autoplay;encrypted-media; gyroscope;picture-in-picture"
                    allowFullScreen
                    className=" w-full"
                  ></iframe>
                </LazyLoad>
              </div>
            </div>
          </div>
        </section>
        <section className="mb-0 pb-10 lg:pb-20">
          <WhatMakeUsDifferent
            title=""
            data={dataJson.dataWhatMakeUsDifferent}
            className="bg-wmud py-[60px]"
          />
        </section>
      </div>
      <section className="relative">
        <div className=" absolute hidden h-1/2 w-full md:block lg:bg-bbc-brand-100"></div>
        <div className="container relative z-10">
          <div className="m-auto lg:col-10">
            <FormCountries
              title={dataJson.dataFormContact.title}
              description={dataJson.dataFormContact.description}
              country_id={191}
            />
          </div>
        </div>
        <Img
          src="/assets/images/wave/opposition_bottom-wave.png"
          width={1920}
          height={86}
          className="hidden  w-full lg:block"
          wrapper={{ className: "absolute w-full top-1/2 hidden md:block" }}
          alt="Wave bottom"
        />
      </section>
      <section>
        <div className="container">
          <div className="lg:col-10 lg:mx-auto">
            <Faqs
              data={dataJson.dataFaqs}
              title={dataJson.dataFaqs.title}
              description={dataJson.dataFaqs.description}
              defaultActiveKey={dataJson.dataFaqs.defaultActiveKey}
              multipleOpen={dataJson.dataFaqs.multipleOpen}
            />
          </div>
        </div>
      </section>
      <section className="mb-10 lg:mb-20">
        <div className="container">
          <Title className="title-h2 m-auto mb-10 w-2/3 pb-0 text-center text-bbc-brand-800">
            Industry News & Insights
          </Title>
          <LazyLoad>
            <NewsSlider data={data} />
          </LazyLoad>
        </div>
      </section>
      <FormNewsLetter
        bgColor="bg-bbc-gradient-14"
        descriptionBellow={
          <div className="mt-4 mb-3 text-left text-white">
            #start-ups, #pre & post incorporation, #corporate bank account, #tax
            advantages, #accounting standards, #audit exemption, #work permit
          </div>
        }
      />
    </>
  );
};

export default SGForeigner;
